import { STATUSES } from "@shared/saas-components/card-status/constants.js";

export default {
  methods: {
    getCardStatusText(status) {
      switch (status) {
        case STATUSES.Confirmed: {
          return this.$t('components.saas.confirmed');
        }
        case STATUSES.Potential: {
          return this.$t('components.saas.potential');
        }
        case STATUSES.Irrelevant: {
          return this.$t('components.saas.false_matches');
        }
        case STATUSES.Unknown: {
          return this.$t('components.saas.unresolved');
        }
        case STATUSES.None: {
          return this.$t('components.saas.unresolved');
        }
        default: {
          return this.$t('components.saas.unresolved');
        }
      }
      // return (status === 'IRRELEVANT' ? 'FALSE MATCHES' :  status === 'UNKNOWN' ? 'UNRESOLVED' : status === "None" ? "UNRESOLVED": status )
    },
  }
}